import axios from "axios";

import CoCart from "@cocart/cocart-rest-api";

const api = new CoCart({
  url: "https://app.takeshapeadventures.com.au",
  consumerKey: process.env.GATSBY_WOO_CONSUMERKEY,
  consumerSecret: process.env.GATSBY_WOO_CONSUMERSECRET,
});

export const add_to_cart = async (product_id, quantity, cookie) => {
  console.log(product_id);
  axios
    .post(
      `https://app.takeshapeadventures.com.au/wp-json/cocart/v1/add-item?cart_key=${cookie}&thumb=true`,
      {
        product_id: product_id.toString(),
        quantity: 1,
      }
    )
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

// Current Cart
export const getCart = async (cookie) => {
  console.log(cookie);
  const curCart = await axios.get(
    `https://app.takeshapeadventures.com.au/wp-json/cocart/v1/get-cart/?cart_key=${cookie}&return_cart=true&thumb=true`
  );
  console.log(curCart);
  return curCart.data;
};

export const remove_from_cart = async (product, cookie) => {
  console.log(product);
  const newCart = await axios.delete(
    `https://app.takeshapeadventures.com.au/wp-json/cocart/v1/item?cart_key=${cookie}&cart_item_key=${product.key}&return_cart=true&thumb=true`
  );
  console.log(newCart);
  return newCart.data.items;
};

export const update_cart = async (product, cookie, quantity) => {
  const newCart = await axios.post(
    `https://app.takeshapeadventures.com.au/wp-json/cocart/v1/item?cart_key=${cookie}&cart_item_key=${product.key}&quantity=${quantity}&return_cart=true&thumb=true`
  );
  console.log(newCart);
  return newCart.data;
};

// Add a product to cart
// export const add_to_cart = (products) => {
//   console.log(products);
//   products.forEach((product) => {
//     console.log(product);
//     const new_item = {
//       product_id: product.product_id || product.product_id,
//       title: product.title,
//       quantity: 1,
//       price: parseFloat(product.price),
//       type: product.productType,
//       ...(product.featuredImage && { image: product.featuredImage }),
//     };

//     if (cart().line_items) {
//       if (
//         !cart().line_items.some(
//           (cur_product) =>
//             cur_product.product_id === product.product_id ||
//             cur_product.product_id === product.product_id
//         )
//       ) {
//         localStorage.setItem(
//           "cart",
//           JSON.stringify({
//             line_items: [
//               ...(cart().line_items ? cart().line_items : []),
//               new_item,
//             ],
//             coupon: cart().coupon || "",
//             discount: cart().discount || 0,
//             total: get_cart_total(
//               [...cart().line_items, new_item],
//               cart().discount || 0
//             ),
//           })
//         );
//       } else {
//         const new_cart = cart().line_items.map((cur_product) => {
//           if (
//             cur_product.product_id === product.product_id ||
//             cur_product.product_id === product.product_id
//           ) {
//             return { ...cur_product, quantity: cur_product.quantity + 1 };
//           } else {
//             return cur_product;
//           }
//         });
//         localStorage.setItem(
//           "cart",
//           JSON.stringify({
//             ...cart(),
//             line_items: new_cart,
//             total: get_cart_total(
//               [...cart().line_items, new_item],
//               cart().discount || 0
//             ),
//           })
//         );
//       }
//     } else {
//       localStorage.setItem(
//         "cart",
//         JSON.stringify({
//           line_items: [new_item],
//           coupon: "",
//           discount: 0,
//           total: new_item.price,
//         })
//       );
//     }
//   });
// };
